<template>
  <div>
    <div class="row mb-3 justify-content-center">
      <div class="col-12 col-xl-10">
        <NavPills
          :model-value="activeIndex"
          :items="navPillItems"
          @update:model-value="switchTab"
        />
      </div>
    </div>

    <!-- Project Types -->
    <project-types v-if="activeTab === 'projectTypes'" />

    <!-- Locations -->
    <locations v-if="activeTab === 'locations'" />

    <!-- Tool Types -->
    <tool-types v-if="activeTab === 'toolTypes'" />

    <!-- Project Assignment Types -->
    <project-assignment-types v-if="activeTab === 'projectAssignmentTypes'" />

    <!-- User Groups -->
    <manage-user-groups v-if="activeTab === 'userGroups'" />

    <!-- Time Registration Groups -->
    <manage-groups v-if="activeTab === 'timeRegistrationGroups'" />

    <!-- Clock-in Locations -->
    <manage-clock-in-locations v-if="activeTab === 'clockInLocations'" />

    <!-- Holiday Calendar -->
    <manage-holidays v-if="activeTab === 'holidays'" />

    <!-- Work Schedules -->
    <manage-work-schedules v-if="activeTab === 'workSchedules'" />

    <!-- Car Custom Fields -->
    <manage-car-custom-fields v-if="activeTab === 'carFields'" />
  </div>
</template>

<script>
import NavPills from "../../components/NavPills.vue";
import ProjectTypes from "../Projects/ProjectTypes.vue";
import Locations from "../Locations/Locations.vue";
import ToolTypes from "../Tools/ToolTypes.vue";
import ProjectAssignmentTypes from "../Projects/ProjectAssignmentTypes.vue";
import ManageUserGroups from "../UserGroups/ManageUserGroups.vue";
import ManageGroups from "../TimeRegistration/ManageGroups.vue";
import ManageClockInLocations from "../TimeRegistration/ManageClockInLocations.vue";
import ManageHolidays from "../TimeRegistration/ManageHolidays.vue";
import ManageWorkSchedules from "../TimeRegistration/ManageWorkSchedules.vue";
import ManageCarCustomFields from "../Cars/ManageCarCustomFields.vue";
import { getCustomerConfig } from './customerConfigHelper';

export default {
  name: "MasterData",
  components: {
    NavPills,
    ProjectTypes,
    Locations,
    ToolTypes,
    ProjectAssignmentTypes,
    ManageUserGroups,
    ManageGroups,
    ManageClockInLocations,
    ManageHolidays,
    ManageWorkSchedules,
    ManageCarCustomFields,
  },
  data() {
    return {
      activeIndex: 0,
      enableProjectTypes: false,
      enableProjectAssignmentTypes: false,
      enableUserGroups: false,
      enableTimeRegistration: false,
      enableSimplifiedTimeRegistration: false,
      requireGpsClockIn: false,
      disableCars: false,
    };
  },
  computed: {
    tabs() {
      const list = [];
      if (this.enableProjectTypes) {
        list.push({ key: 'projectTypes', label: this.$t('sidebar.projectTypes'), icon: 'category' });
      }
      list.push({ key: 'locations', label: this.$t('sidebar.locations'), icon: 'place' });
      list.push({ key: 'toolTypes', label: this.$t('sidebar.toolTypes'), icon: 'build' });
      if (this.enableProjectAssignmentTypes) {
        list.push({ key: 'projectAssignmentTypes', label: this.$t('sidebar.projectAssigmentTypes') || 'Assignment Types', icon: 'assignment' });
      }
      if (this.enableUserGroups) {
        list.push({ key: 'userGroups', label: this.$t('sidebar.userGroups'), icon: 'groups' });
      }
      if (this.enableTimeRegistration && this.enableSimplifiedTimeRegistration) {
        list.push({ key: 'timeRegistrationGroups', label: this.$t('sidebar.timeRegistrationGroups') || 'Tímaskráningarhópar', icon: 'groups' });
      }
      if (this.enableTimeRegistration && this.requireGpsClockIn) {
        list.push({ key: 'clockInLocations', label: this.$t('sidebar.timeRegistrationClockInLocations') || 'Tímaskráningarstaðir', icon: 'place' });
      }
      if (this.enableTimeRegistration) {
        list.push({ key: 'holidays', label: this.$t('sidebar.holidays') || 'Frídagar', icon: 'event' });
        list.push({ key: 'workSchedules', label: this.$t('sidebar.workSchedules') || 'Vinnuskipulag', icon: 'calendar_month' });
      }
      if (!this.disableCars) {
        list.push({ key: 'carFields', label: this.$t('cars.customFields'), icon: 'directions_car' });
      }
      return list;
    },
    navPillItems() {
      return this.tabs.map(t => ({ label: t.label, icon: t.icon }));
    },
    activeTab() {
      return this.tabs[this.activeIndex]?.key || '';
    },
  },
  created() {
    getCustomerConfig('EnableProjectTypes').then(config => {
      this.enableProjectTypes = config === '' ? false : config;
    });
    getCustomerConfig('EnableProjectAssignmentTypes').then(config => {
      this.enableProjectAssignmentTypes = config === '' ? false : config;
    });
    getCustomerConfig('EnableUserGroups').then(config => {
      this.enableUserGroups = config === '' ? false : config;
    });
    getCustomerConfig('EnableTimeRegistration').then(config => {
      this.enableTimeRegistration = config === '' ? false : config;
    });
    getCustomerConfig('EnableSimplifiedTimeRegistration').then(config => {
      this.enableSimplifiedTimeRegistration = config === '' ? false : config;
    });
    getCustomerConfig('RequireGpsClockIn').then(config => {
      this.requireGpsClockIn = config === '' ? false : config;
    });
    getCustomerConfig('DisableCars').then(config => {
      this.disableCars = config === '' ? false : config;
    });
  },
  methods: {
    switchTab(index) {
      this.activeIndex = index;
    },
  },
};
</script>
